import { computed, shallowRef } from 'vue-demi';
import { v3Url } from '@/utils/fetcher';
import useItemLoader from '../base/useItemLoader';
import { useRealTimeUpdates } from '../base/useRealTimeUpdates';

const PROJECT_ADDED_ACTION = 'added';

function responseToItem(response) {
  return response.data.projectNumberSettings;
}

/**
 * Loads the project numbering settings of the account: the pattern, the next counter value and
 * others. The read needs administrator or add-projects permission. For any other user the v3
 * endpoint returns 403. Callers pass `enabled: false` for such a user and when the feature flag is
 * off.
 */
export default function useProjectNumberingLoader({ enabled: _enabled = true } = {}) {
  const enabled = shallowRef(_enabled);
  const url = computed(() => enabled.value && v3Url('projects/number'));
  const { state, refresh } = useItemLoader({
    url,
    responseToItem,
  });

  // Another project created elsewhere (eg a teammate, or a second dialog) advances the
  // backend counter, so refetch to keep this session's preview from going stale.
  useRealTimeUpdates((event) => {
    if (event.type === 'project' && event.action === PROJECT_ADDED_ACTION) {
      refresh();
    }
  });

  return state;
}
